export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/sync-worker.cfaa1688.worker.js");
}
